<template>
  <v-toolbar class="mr-4 subPrimary" :height="toolbarHeight" :extension-height="32" :extended="isVehicleSelected">
    <div class="start-items" style="width:100%">
      <div class="cursor-pointer">
        <img :src="skin.logo_url"  @click="goLogo()">
      </div>
      <v-toolbar-title v-if="!$isPhoneDevice">MAYOREO DE AUTOPARTES Y ACEITES S.A. DE C.V.</v-toolbar-title>
    </div>

    <template v-if="isVehicleSelected" slot="extension">
      <v-flex xs12  text-xs-center primary>
        <v-alert :value="true" outline class="pa-0 subPrimary--text">
          <v-icon class="mr-2">directions_car</v-icon>
          <span>
            <strong v-if="!$isPhoneDevice">{{ $t('Toolbar.Labels.SelectedVehicle') }}:</strong>
            {{ selectedVehicleText }}
          </span>
          <template v-if="$isMobileDevice">
            <!-- Cambiar la ruta -->
            <v-menu offset-y>
              <v-icon slot="activator" class="ml-2" medium>menu</v-icon>
              <v-list style="background-color:white">
                <v-list-tile @click="editVehicle">
                  <v-list-tile-title class="text-xs-center black--text">
                    {{ $t('Toolbar.Actions.ChangeVehicle') }}
                    <v-icon>edit</v-icon>
                  </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="resetVehicle">
                  <v-list-tile-title class="text-xs-center black--text">
                    {{ $t('Toolbar.Actions.RemoveVehicle') }}
                    <v-icon>delete</v-icon>
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <template v-if="!$isMobileDevice">
            <v-tooltip :color="skin.primary_color" bottom>
              <v-icon slot="activator" class="ml-2" small @click="resetVehicle">delete</v-icon>
              <span>{{ $t('Toolbar.Actions.RemoveVehicle') }}</span>
            </v-tooltip>
            <v-tooltip :color="skin.primary_color" bottom>
              <v-icon slot="activator" class="ml-2" small @click="editVehicle">edit</v-icon>
              <span :color="skin.primary_color">{{ $t('Toolbar.Actions.ChangeVehicle') }}</span>
            </v-tooltip>
          </template>
        </v-alert>
      </v-flex>
    </template>
  </v-toolbar>
</template>

<script>
import { MESSAGES, inPage, to  } from "@/utils";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "Toolbar",
  data() {
    return {
      toolbarHeight: 64,
      provider: this.$route.params.provider
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    }),
    ...mapGetters({
      selectedVehicleText: "vehicle/selectedVehicleText",
      isVehicleSelected: "vehicle/isVehicleSelected"
    })
  },
  methods: {
    inPage,
    to,
    ...mapActions({
      RESET_VEHICLE: "vehicle/RESET_VEHICLE",
      SHOW_SNACKBAR: "snackbar/SHOW_SNACKBAR",
      TOGGLE_DRAWER: "settings/TOGGLE_DRAWER",
      RESET_PARTS: "parts/RESET_PARTS_LOOKUP",
      TOGGLE_MODAL_STATE: "modals/TOGGLE_MODAL_STATE",
      RESET_PART_LIST: "parts/RESET_PART_LIST",
    }),
    resetVehicle() {
      this.RESET_PARTS();
      this.RESET_PART_LIST();
      this.RESET_VEHICLE();
      if(!this.inPage('new-vehicle')) {
        this.to('new-vehicle')
      }
      this.SHOW_SNACKBAR(MESSAGES.VEHICLE_REQUIRED);
    },
    async editVehicle() {
      if(!this.inPage('new-vehicle')){
        this.RESET_PART_LIST();
        this.to('new-vehicle')
      }
      this.RESET_PART_LIST();
    },
    goLogo() {
      if(!this.inPage('new-vehicle'))
        this.to('new-vehicle')
        this.RESET_PART_LIST();

    }
  }
};
</script>

<style lang="stylus" scoped>
:deep().v-toolbar__extension {
  height: auto !important;
  padding: 0;

  .v-alert.v-alert--outline {
    border: none !important;
    font-size: 1em;

    div {
      justify-content: center;
      display: flex;
      align-items: center;
    }
  }
}
:deep().logo-container {
    padding: 8px;
    max-width: 300px;
    height: 64px;
    max-height: 48px;
    box-sizing: content-box;

    img {
      height: 100%;
    }
  }

:deep().v-toolbar__content {
    justify-content: space-between;
    position: relative;

    .start-items,
    .end-items {
      display flex;
      width 400px;
      align-items center
    }

    .start-items {
      justify-content flex-start;
    }

    .end-items {
      justify-content flex-end;
      height 100%
    }
  }
  .heightBar {
    max-height: 10px;

  }
</style>
